"use strict";

module.exports = function () {
    const errorContainer = $(".g-recaptcha-response-error").length ? ".g-recaptcha-response-error" : ".customer-error";

    $("body").on("click", ".clear-errors", function (e) {
        e.preventDefault();
        $(errorContainer).empty();
    });
};
